module.exports = __webpack_public_path__ + "img/file__icon-text.25821a76.svg";